import React, { useCallback } from 'react';
import clsx from 'clsx';

import { Button } from 'ui';

import { ReactComponent as Basket } from 'assets/images/icons/basket.svg';
import { ReactComponent as WhiteWarningCircle } from 'assets/images/icons/whiteWarningCircle.svg';

import style from './mainReservationBtn.module.scss';

const MainReservationBtn = ({
  handleAddProduct,
  isMaxQuantityReached,
  additionalClassName,
  isBookNowDisabled,
  postcodeError,
}) => {
  const handleBtnClick = useCallback(() => {
    handleAddProduct();
  }, [handleAddProduct]);

  return isMaxQuantityReached ? (
    <Button
      prefixIcon={<WhiteWarningCircle />}
      noWrap
      className={clsx(
        style.mainButton,
        isMaxQuantityReached && style.mainButtonDisabled,
        additionalClassName,
      )}
      data-testid="btn-addToReservation"
    >
      Max Quantity is Reached
    </Button>
  ) : (
    <Button
      prefixIcon={
        <Basket width="20px" height="20px" style={{ marginRight: '4px' }} />
      }
      onClick={handleBtnClick}
      noWrap
      disabled={isBookNowDisabled || postcodeError}
      className={clsx(style.mainButton, additionalClassName)}
      data-testid="btn-addToReservation"
      small
    >
      Book now
    </Button>
  );
};

export default MainReservationBtn;
